
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form17";
const form17State = namespace("Form17");

import Form17ProcessHeader from "@/components/process/Form17/components/Form17ProcessHeader.vue";
import Form17 from "@/components/process/Form17/components/pdf/Form17.vue"

import { form17StatusInfoType } from '@/types/Information/Form17';

@Component({
    components:{
        Form17ProcessHeader,
        Form17
    }
})
export default class PreviewForm17 extends Vue {

    @form17State.State
    public currentCertificateOfCostsId: string;

    stepsCompleted = {} as form17StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form17" }); 
    }
}
